export function bindMouseEvent(element, cb) {
  const listener = evt => {
    const delta = Math.max(-1, Math.min(1, evt.wheelDelta || -evt.detail));
    cb(evt, delta);
  };

  element.addEventListener('mousewheel', listener, false);
  element.addEventListener('DOMMouseScroll', listener, false);
}



// WEBPACK FOOTER //
// ./src/utils/mouse-wheel.js